import { render } from "./CartFooterSummary.vue?vue&type=template&id=78d15e2a&scoped=true"
import script from "./CartFooterSummary.vue?vue&type=script&lang=js"
export * from "./CartFooterSummary.vue?vue&type=script&lang=js"

import "./CartFooterSummary.vue?vue&type=style&index=0&id=78d15e2a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d15e2a"]])

export default __exports__